import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Trophy, ChevronRight } from "lucide-react";
import { API } from "../../App";

// "Your week" House Points strip for the dashboard. Celebrates new points once per device.
export default function PointsStrip({ headers, isRetreat }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!headers || isRetreat) return;
    axios.get(`${API}/points/me`, { headers })
      .then((r) => setData(r.data))
      .catch(() => {});
  }, [headers, isRetreat]);

  if (!data || isRetreat) return null;
  const { week_points, rank_week, players_week, total_points, level, badge_count, next_badges = [] } = data;
  const pct = Math.max(0, Math.min(100, Math.round(level?.progress_to_next || 0)));

  return (
    <Link
      to="/community?tab=game"
      className="block rounded-xl border border-stone-200 bg-white px-3.5 py-3 shadow-sm shadow-stone-200/50 active:scale-[0.98] transition-transform"
      data-testid="points-strip"
    >
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-[#F4ECE2] flex items-center justify-center flex-shrink-0">
          <Trophy className="w-5 h-5 text-[#C85A38]" strokeWidth={1.8} />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-baseline gap-2">
            <p className="font-medium text-[#1A1A1A] text-sm leading-tight">
              {week_points > 0 ? `${week_points} pts this week` : "0 pts this week"}
            </p>
            {rank_week && (
              <span className="text-[11px] text-[#C85A38] font-semibold" data-testid="points-rank">
                #{rank_week}{players_week ? ` of ${players_week}` : ""}
              </span>
            )}
          </div>
          <p className="text-[11px] text-[#1A1A1A]/50 mt-0.5 truncate">
            {level?.name} · {total_points} pts · {badge_count} {badge_count === 1 ? "badge" : "badges"}{level?.points_to_next ? ` · ${level.points_to_next} to ${nextLevelName(level.level)}` : ""}
          </p>
          <div className="mt-1.5 h-1.5 rounded-full bg-[#E8DAC8] overflow-hidden" aria-hidden="true">
            <div className="h-full bg-[#C85A38] rounded-full transition-[width] duration-700" style={{ width: `${pct}%` }} />
          </div>
        </div>
        <ChevronRight className="w-4 h-4 text-[#1A1A1A]/20 flex-shrink-0" strokeWidth={1.6} />
      </div>
      {next_badges.length > 0 && (
        <div className="mt-2.5 flex items-center gap-1.5 overflow-x-auto no-scrollbar" data-testid="points-next-badges">
          <span className="text-[10px] uppercase tracking-wider text-[#1A1A1A]/40 flex-shrink-0">Level up</span>
          {next_badges.map((b) => (
            <span key={b.id} className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] whitespace-nowrap ${b.pending ? "bg-amber-50 text-amber-800" : "bg-[#FBF7F1] text-[#1A1A1A]/75"}`}>
              {b.icon} {b.name} <span className="font-semibold text-[#C85A38]">+{b.points}</span>
            </span>
          ))}
        </div>
      )}
    </Link>
  );
}

const nextLevelName = (lvl) => ({ 1: "Explorer", 2: "Regular", 3: "Veteran", 4: "Legend" }[lvl] || "Legend");
